export default __webpack_public_path__ + "static/media/Cross.4217e039.svg";